import { ConsumersState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
  consumers: (state: ConsumersState) => state.consumers,
  consumerResult: (state: ConsumersState) => state.consumerResult,
  consumerError: (state: ConsumersState) => state.consumerError,
  consumerPasswordError: (state: ConsumersState) => state.consumerPasswordError,
  consumer: (state: ConsumersState) => (id: number) => {
    const items = state.consumers.filter((consumer) => consumer.id === id);
    if (items.length > 0) {
      return { ...items[0] };
    }
  },
  consumerStats: (state: ConsumersState) => state.stats,
};

const { read } = getStoreAccessors<ConsumersState, State>('');

export const readConsumers = read(getters.consumers);
export const readConsumerResult = read(getters.consumerResult);
export const readConsumerError = read(getters.consumerError);
export const readConsumerPasswordError = read(getters.consumerPasswordError);
export const readOneConsumer = read(getters.consumer);
export const readConsumerStats = read(getters.consumerStats);
